import sithMesPrdDispatchWorks from "@/views/sithMes/prd/SithMesPrdDispatchWorks";
import sithMesPrdPpOperationDispatchList from "@/views/sithMes/prd/SithMesPrdPpOperationDispatchList";
import sithMesPrdPpOperationExecuteList from "@/views/sithMes/prd/SithMesPrdPpOperationExecuteList";
import SithMesPrdOperationExecute from "@/views/sithMes/prd/PrdOperationExcute/SithMesPrdOperationExecute.vue";
import sithMesPrdProjectPlanDetailPpdGantt from "@/views/sithMes/prd/SithMesPrdProjectPlanDetailPpdGantt.vue";
import sithMesPrdProjectPlanAdjust from "@/views/sithMes/prd/SithMesPrdProjectPlanAdjust.vue";
import sithMesPrdProjectKamSelection from "@/views/sithMes/prd/SithMesPrdProjectKamSelection.vue"
import ProjectPlanAdjust from "@/views/sithMes/prd/ProjectPlanAdjust.vue";

const metaObject = {
    requiresAuth: true,
    roles: ['mmf']
};

export default [
    {
        path: "/sithMes/prd/SithMesPrdOperationExecute",
        name: "SithMesPrdOperationExecute",
        component: SithMesPrdOperationExecute,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdDispatchWorks",
        name: "sithMesPrdDispatchWorks",
        component: sithMesPrdDispatchWorks,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/SithMesPrdPpOperationDispatchList",
        name: "sithMesPrdPpOperationDispatchList",
        component: sithMesPrdPpOperationDispatchList,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/SithMesPrdPpOperationExecuteList",
        name: "sithMesPrdPpOperationExecuteList",
        component: sithMesPrdPpOperationExecuteList,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanDetailPpdGantt",
        name: "sithMesPrdProjectPlanDetailPpdGantt",
        component: sithMesPrdProjectPlanDetailPpdGantt,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanAdjust",
        name: "sithMesPrdProjectPlanAdjust",
        component: sithMesPrdProjectPlanAdjust,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectKamSelection",
        name: "sithMesPrdProjectKamSelection",
        component: sithMesPrdProjectKamSelection,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/projectPlanAdjust",
        name: "projectPlanAdjust",
        component: ProjectPlanAdjust
    }
]
